import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchSettlements, markSettled, markUnsettled } from '../api/settlements'

export function useSettlements() {
  return useQuery({
    queryKey: ['settlements'],
    queryFn: fetchSettlements,
  })
}

export function useMarkSettled() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: markSettled,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settlements'] })
    },
  })
}

export function useMarkUnsettled() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: markUnsettled,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settlements'] })
    },
  })
}
